import { type FC, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';

// ---------------------------------------------------------------------------
// 숫자 변경 시 rAF 트윈 (ease-out cubic) — 오도미터 카운터용
// ---------------------------------------------------------------------------

interface AnimatedNumberProps {
  value: number;
  duration?: number; // ms
  className?: string;
}

export const AnimatedNumber: FC<AnimatedNumberProps> = ({ value, duration = 800, className }) => {
  const [display, setDisplay] = useState(value);
  const prevRef = useRef(value);
  const rafRef = useRef(0);

  useEffect(() => {
    const from = prevRef.current;
    const to = value;
    if (from === to) return;
    prevRef.current = to;
    const start = performance.now();
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
      setDisplay(Math.round(from + (to - from) * eased));
      if (t < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value, duration]);

  return <span className={clsx('data-mono', className)}>{display.toLocaleString('en-US')}</span>;
};
